export default __webpack_public_path__ + "static/media/medals2.511d0c57.svg";